import { useMemo, useState } from "react";
import mapa from "../../data/brazil-states.json";
import { formatCompact, formatNumber } from '../../lib/dashboard-data';
const STATES = mapa.states;
function BrazilMap({ dados = [] }) {
  const [hover, setHover] = useState(null);
  const porUf = useMemo(() => {
    const m = /* @__PURE__ */ new Map();
    for (const d of dados) m.set(d.uf, d);
    return m;
  }, [dados]);
  const max = useMemo(
    () => Math.max(1, ...dados.map((d) => d.valor)),
    [dados]
  );
  const selecionado = hover ? porUf.get(hover) : void 0;
  const estadoSelecionado = STATES.find((s) => s.sigla === hover);
  return <div className="relative flex h-full w-full flex-col">
      <svg
    viewBox={`0 0 ${mapa.width} ${mapa.height}`}
    className="h-full w-full flex-1"
    role="img"
    aria-label="Mapa do Brasil com faturamento por estado"
  >
        <defs>
          <filter id="glow-uf" x="-40%" y="-40%" width="180%" height="180%">
            <feGaussianBlur stdDeviation="6" result="b" />
            <feMerge>
              <feMergeNode in="b" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        {STATES.map((estado) => {
    const dado = porUf.get(estado.sigla);
    const intensidade = dado ? Math.pow(dado.valor / max, 0.55) : 0;
    const ativo = hover === estado.sigla;
    return <path
      key={estado.sigla}
      d={estado.d}
      fill={`hsl(217 91% ${Math.round(16 + intensidade * 46)}%)`}
      stroke={ativo ? "#34d399" : "#334155"}
      strokeWidth={ativo ? 2.5 : 1}
      className="cursor-pointer transition-[stroke,stroke-width,opacity] duration-200"
      opacity={hover && !ativo ? 0.45 : 1}
      onMouseEnter={() => setHover(estado.sigla)}
      onMouseLeave={() => setHover(null)}
    />;
  })}

        {STATES.map((estado) => {
    const dado = porUf.get(estado.sigla);
    if (!dado || dado.valor <= 0) return null;
    const r = 4 + Math.sqrt(dado.valor / max) * 20;
    return <g key={`b-${estado.sigla}`} pointerEvents="none">
              <circle
      cx={estado.cx}
      cy={estado.cy}
      r={r}
      fill="#fbbf24"
      opacity={0.18}
      filter="url(#glow-uf)"
    />
              <circle
      cx={estado.cx}
      cy={estado.cy}
      r={Math.max(2.5, r * 0.28)}
      fill="#fbbf24"
    />
              <text
      x={estado.cx}
      y={estado.cy - r - 5}
      textAnchor="middle"
      fill="#f8fafc"
      className="font-mono"
      fontSize={15}
      fontWeight={700}
    >
                {estado.sigla}
              </text>
            </g>;
  })}
      </svg>

      <div className="pointer-events-none absolute left-0 top-0 min-h-[52px]">
        {selecionado && estadoSelecionado ? <div className="rounded-md border border-border bg-popover/95 px-3 py-2 shadow-lg backdrop-blur">
            <p className="text-xs font-bold uppercase tracking-wider text-foreground">
              {estadoSelecionado.nome}
            </p>
            <p className="font-mono text-sm font-bold text-amber-400">
              {formatCompact(selecionado.valor)}
            </p>
            <p className="font-mono text-[10px] text-muted-foreground">
              {formatNumber(selecionado.pedidos)} pedidos · {estadoSelecionado.regiao}
            </p>
          </div> : <p className="font-mono text-[10px] uppercase tracking-wider text-muted-foreground">
            Passe o cursor sobre um estado
          </p>}
      </div>

      <div className="mt-2 flex items-center gap-2">
        <span className="font-mono text-[9px] uppercase text-muted-foreground">Menor</span>
        <div className="h-1.5 flex-1 rounded-full bg-gradient-to-r from-blue-950 to-blue-400" />
        <span className="font-mono text-[9px] uppercase text-muted-foreground">
          {formatCompact(max)}
        </span>
      </div>
    </div>;
}
export {
  BrazilMap
};
